export enum TimesheetTypeEnum {
  LOAD = 1,
  DISCHARGE,
  BUNKER
}

export enum EventItemEnum {
  OTHERS = 999
}

export const TimesheetTypes = [
  {
    id: TimesheetTypeEnum.LOAD,
    name: 'CARGO LOAD',
    description: 'Cargo Loading',
    gridColor: 'text-red-600 border-red-600',
    color: 'text-red-600 bg-red-100',
    dot: 'bg-red-600'
  },
  {
    id: TimesheetTypeEnum.DISCHARGE,
    name: 'CARGO DISCHARGE',
    description: 'Cargo Discharge',
    gridColor: 'text-blue-600 border-blue-600',
    color: 'text-blue-600 bg-blue-100',
    dot: 'bg-blue-600'
  },
  {
    id: TimesheetTypeEnum.BUNKER,
    name: 'BUNKER',
    description: 'Bunkering',
    gridColor: 'text-yellow-600 border-yellow-600',
    color: 'text-yellow-600 bg-yellow-100',
    dot: 'bg-yellow-600'
  }
];

export enum TimesheetStatusEnum {
  DRAFT = 1,
  ISSUED
}

export const TimesheetStatuses = [
  {
    id: TimesheetStatusEnum.DRAFT,
    name: 'Draft',
    color: 'text-orange-500 border-orange-500 bg-orange-50 dark:text-orange-50 dark:bg-orange-500',
    dot: 'bg-orange-500'
  },
  { id: TimesheetStatusEnum.ISSUED, name: 'Issued', color: 'text-blue-600 border-blue-600 bg-blue-50 dark:text-blue-50 dark:bg-blue-600', dot: 'bg-blue-600' }
];
